export const environment = {
  production: true,
  tenantId: '2eebd8ff-9ed1-40f0-a156-38e5dfb3bc56',
  clienId: '8a04e56c-ce8c-4f40-bdd7-1abac04a6497',
  authority: 'https://login.microsoftonline.com/2eebd8ff-9ed1-40f0-a156-38e5dfb3bc56',
  redirectUrl: 'https://dev.SesameWms.it6.aaas.org/signin-oidc',
  logoutUrl: 'https://dev.SesameWms.it6.aaas.org/signin-oidc',
  postLogoutRedirectUri: 'https://dev.SesameWms.it6.aaas.org/signin-oidc',
};
